import './bootstrap';
import utils from './utils';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import { i18nVue } from 'laravel-vue-i18n';
import VueCookies from 'vue-cookies';

import.meta.glob([
    '../images/**',
]);

// const appName = 'Laravel';
// const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'miniBUD';
const appName = 'miniBUD';

const app = createInertiaApp({
    title: (title) => `${title} | ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(i18nVue, {
                lang: document.documentElement.lang,
                // lang: 'hu',
                resolve: (lang) => import(`../../lang/${lang}.json`)
            })
            .use(VueCookies);

        app.config.globalProperties.$utils = utils;

        return app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

import './common';
